import { DEFAULT_COLOR } from "../global";
import Box from "./box";
import Desktop from "./desktop";
import Reel from "./reel";
import Table from "./table";
import Element from "./element";

/* Deserializer from Json */
export default function elementFromJson(elt: ElementDefS): Element {
	const { id, type, color = DEFAULT_COLOR, props } = elt;
	switch (type) {
		case "box": {
			const { width, height, depth } = props;
			return new Box({ id, color, width, height, depth });
		}
		case "table": {
			const {
				width = 0.01,
				height = 0.01,
				depth = 0.01,
				topHeight = 0.01,
				footWidth = 0.01
			} = props;
			return new Table({ id, color, width, height, depth, topHeight, footWidth });
		}
		case "desktop": {
			const {
				width = 0.01,
				height = 0.01,
				depth = 0.01,
				topHeight = 0.01,
				footWidth = 0.01
			} = props;
			return new Desktop({ id, color, width, height, depth, topHeight, footWidth });
		}
		case "reel": {
			const { width = 0.01, height = 0.01, topHeight = 0.01, footWidth = 0.01 } = props;
			return new Reel({ id, color, width, height, topHeight, footWidth });
		}
	}
	throw new Error(`Unknown element type '${type}' for '${id}'`);
}
